module.exports = __webpack_public_path__ + "img/undraw_report_red.3516d03e.svg";